/**
 * phase-form-template-versioning — the ONE display rule for template version
 * numbers (D-059, single-track): the stored integer N renders as "N.0".
 * There is no major/minor semantics; the ".0" exists so a version reads as a
 * document revision ("2.0"), not a count. Every surface showing a template
 * version formats through this helper.
 */
export function templateVersionLabel(version: number | null | undefined): string {
  return version == null ? '—' : `${version}.0`;
}
